import { Input } from "./common";
import { useApp } from "./context";

export function Account() {
    const { cache } = useApp();

    return <PasswordReset />
}

function PasswordReset() {
    var email;
    var password;

    function submit() {

    }

    return <div>
        <Input
            label="Email"
            type="email"
            autocomplete="email"
            ref={email} />
        <Input
            label="Password"
            type="password"
            autocomplete="new-password"
            ref={password} />
        <button type="submit" on:click={submit}>
            Login
        </button>
    </div>
}
